import { apiClient } from '@/api/client'
import type { Notification, NotificationPreferences, PaginatedResponse } from '@/types'

// ─── Types ────────────────────────────────────────────────────────────

export interface NotificationsParams {
  page?: number
  page_size?: number
  notification_type?: string
  is_read?: boolean
}

// ─── API Calls ────────────────────────────────────────────────────────

export const notificationsApi = {
  /** Paginated notification list */
  getNotifications: (params?: NotificationsParams) =>
    apiClient
      .get<PaginatedResponse<Notification>>('/api/notifications/', { params })
      .then((r) => r.data),

  /** Mark specific notifications as read */
  markRead: (ids: string[]) =>
    apiClient
      .post<{ status: boolean }>('/api/notifications/mark-read/', { notification_ids: ids })
      .then((r) => r.data),

  /** Mark all notifications as read */
  markAllRead: () =>
    apiClient
      .post<{ status: boolean }>('/api/notifications/mark-read/', { all: true })
      .then((r) => r.data),

  /** Get unread notification count */
  getUnreadCount: () =>
    apiClient
      .get<{ unread_count: number }>('/api/notifications/unread-count/')
      .then((r) => r.data.unread_count),

  /** Get notification preferences */
  getPreferences: () =>
    apiClient
      .get<NotificationPreferences>('/api/notifications/preferences/')
      .then((r) => r.data),

  /** Update notification preferences */
  updatePreferences: (prefs: Partial<NotificationPreferences>) =>
    apiClient
      .put<NotificationPreferences>('/api/notifications/preferences/', prefs)
      .then((r) => r.data),
}
